import { render, staticRenderFns } from "./businessAddress.vue?vue&type=template&id=9aef3f50"
import script from "./businessAddress.vue?vue&type=script&lang=js"
export * from "./businessAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports